var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("generate-codebox-code-modal", { ref: "generateCodeboxCodeModal" }),
      _c("addDevicesDialog", {
        ref: "addDevicesDialog",
        on: { added: _vm.deviceAdded }
      }),
      _c("div", { staticClass: "row full-row-exactly" }, [
        _c("div", { staticClass: "col-12 flex-1" }, [
          _c(
            "div",
            {
              staticClass: "gutter-sm",
              class: _vm.$q.screen.lt.md ? "column" : "row"
            },
            [
              _vm.$q.screen.lt.md || _vm.showFiltersDesktop
                ? _c(
                    "div",
                    {
                      class:
                        _vm.$q.screen.lt.md && !_vm.showFiltersMobile
                          ? "col-auto"
                          : "col-md-3"
                    },
                    [
                      _c(
                        "q-card",
                        { class: _vm.$q.screen.gt.sm ? "full-height" : "" },
                        [
                          _c("q-card-title", [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col" }, [
                                _vm._v(
                                  "\n                  Filters\n                "
                                )
                              ]),
                              _vm.$q.screen.lt.md
                                ? _c(
                                    "div",
                                    { staticClass: "col-auto q-mr-auto" },
                                    [
                                      _c("q-btn", {
                                        attrs: {
                                          color: "secondary",
                                          flat: "",
                                          round: "",
                                          icon:
                                            "keyboard_arrow_" +
                                            (_vm.showFiltersMobile
                                              ? "up"
                                              : "down")
                                        },
                                        on: { click: _vm.toggleFiltersMobile }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm.$q.screen.gt.sm || _vm.showFiltersMobile
                            ? _c(
                                "q-card-main",
                                {
                                  staticStyle: { height: "calc(100% - 64px)" }
                                },
                                [
                                  _c(
                                    _vm.$q.screen.gt.sm
                                      ? "q-scroll-area"
                                      : "div",
                                    {
                                      tag: "component",
                                      class: {
                                        "full-height": _vm.$q.screen.gt.sm
                                      }
                                    },
                                    [
                                      _c("bj-filters", {
                                        key: _vm.filtersResetReRenderKey,
                                        ref: "filtersModal",
                                        attrs: { fields: _vm.filterFields },
                                        on: {
                                          reset: function($event) {
                                            _vm.filtersResetReRenderKey++
                                          },
                                          input: _vm.initFilters
                                        },
                                        model: {
                                          value: _vm.filters,
                                          callback: function($$v) {
                                            _vm.filters = $$v
                                          },
                                          expression: "filters"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("bj-data-table", {
                    ref: "dataTable",
                    attrs: {
                      "with-cell-delete-button": false,
                      "add-button-label": "Add Devices",
                      columns: _vm.columns,
                      model: "admin/devices",
                      "many-name": "Devices",
                      "single-name": "Device",
                      "query-params": _vm.queryParams,
                      "filter-button": "",
                      "with-cell-edit-button": false,
                      "with-cell-add-button": false
                    },
                    on: {
                      add: _vm.openAddModal,
                      "toggle-filters": _vm.toggleFiltersDesktop
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell-business",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "app.businesses.profile",
                                    params: { id: row.business_id }
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(row.business.name) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "cell-provider",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(row.provider) +
                                "\n            "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell-serial-number",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(row.serial_number) +
                                "\n            "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell-unit",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            (row.units && row.units.length) || row.unit
                              ? [
                                  _vm._l(
                                    row.units || (row.unit ? [row.unit] : []),
                                    function(unit, idx) {
                                      return [
                                        _c(
                                          "router-link",
                                          {
                                            key: unit.id,
                                            attrs: {
                                              to: {
                                                name: "app.properties.combined",
                                                params: { id: unit.property_id }
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  unit.property
                                                    ? (
                                                        unit.property
                                                          .short_address +
                                                        " - " +
                                                        (unit.name || "")
                                                      ).trim()
                                                    : ""
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        idx <
                                        (
                                          row.units ||
                                          (row.unit ? [row.unit] : [])
                                        ).length -
                                          1
                                          ? _c(
                                              "span",
                                              { key: "sep-" + unit.id },
                                              [_vm._v(", ")]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  )
                                ]
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "cell-status",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(row.device_status) +
                                "\n            "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell-actions",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            (row.units && row.units.length) || row.unit
                              ? _c("q-btn", {
                                  directives: [
                                    { name: "tippy", rawName: "v-tippy" }
                                  ],
                                  staticClass: "q-ml-sm",
                                  attrs: {
                                    size: "sm",
                                    rounded: "",
                                    outline: "",
                                    color: "primary",
                                    icon: "fas fa-key",
                                    title: "Generate device code"
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.openGenerateCodeboxCodeModal(row)
                                    }
                                  }
                                })
                              : _vm._e(),
                            row.provider !== _vm.AccessHardware.CODEBOX
                              ? _c("q-btn", {
                                  directives: [
                                    { name: "tippy", rawName: "v-tippy" }
                                  ],
                                  staticClass: "q-ml-sm",
                                  attrs: {
                                    size: "sm",
                                    rounded: "",
                                    outline: "",
                                    color: "negative",
                                    icon: "delete",
                                    title: "Delete Device"
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.deleteDevice(row)
                                    }
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }